import React, { useEffect, useState } from 'react';

const ImageWithFallback = ({ 
  src, 
  alt, 
  className = "", 
  fallbackSrc = "/default.png",
  onError,
  loading = "lazy",
  ...props 
}) => {
  const [imgSrc, setImgSrc] = useState(src || fallbackSrc);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setImgSrc(src || fallbackSrc);
    setHasError(false);
  }, [src, fallbackSrc]);

  const handleError = (event) => {
    if (!hasError) {
      setHasError(true);
      setImgSrc(fallbackSrc);

      // Suppress 404 error in console for missing images
      event.preventDefault();

      if (onError) {
        onError();
      }
    }
  };

  return (
    <img
      src={imgSrc}
      alt={alt}
      className={className}
      loading={loading}
      decoding="async"
      onError={handleError}
      {...props}
    />
  );
};

export default ImageWithFallback;
